import { IonContent, IonList } from '@ionic/react';
import { Form } from 'formik';
import { ReactElement } from 'react';
import { useRoleFormContext } from '../../api/hooks/role.hooks';
import { getLocalizedText } from '../../i18n/i18n.utils';
import { ContentLoading } from '../loading/content-loading';
import { RolePermissionsFormEntity } from './role-permissions-form-entity';
import { sortRolePermissionFormData } from './role.utils';

interface RoleEntitiesProps {
  onSelectedPermissionEntity: (permissionEntity: string) => void;
}

const RoleEntities = (props: RoleEntitiesProps): ReactElement => {
  const { onSelectedPermissionEntity } = props;

  const { isRolePermissionFormLoading, rolePermissionFormFields } =
    useRoleFormContext();

  const sortedRolePermissionFormFields = sortRolePermissionFormData({
    rolePermissionFormFields,
  });

  const formEntities = Object.entries(sortedRolePermissionFormFields).map(
    ([entity], index, arr) => {
      const isLast = index === arr.length - 1;
      return (
        <RolePermissionsFormEntity
          key={entity}
          entity={entity}
          onSelected={onSelectedPermissionEntity}
          itemProps={{
            lines: isLast ? 'none' : 'full',
          }}
        />
      );
    }
  );

  return (
    <>
      <IonContent>
        {isRolePermissionFormLoading ? (
          <ContentLoading
            message={getLocalizedText('common:loading_role_permissions')}
          />
        ) : (
          <Form>
            <IonList>{formEntities}</IonList>
          </Form>
        )}
      </IonContent>
    </>
  );
};

export { RoleEntities };
